function isAndroidWebView() {
  return /wv|Version\/\d+\.\d+/i.test(navigator.userAgent) && /Android/i.test(navigator.userAgent);
}

function isIOSWebView() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !/Safari/i.test(navigator.userAgent);
}

function isWebViewContainer() {
  return isAndroidWebView() || isIOSWebView();
}

export { isWebViewContainer };
